var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "quiz__tips" }, [
    _c("header", [_c("h2", [_vm._v(_vm._s(_vm.$t("quiz.list[19].title")))])]),
    _vm._v(" "),
    _c("div", { staticClass: "tips__list" }, [
      _c("div", { staticClass: "tip" }, [
        _c("img", {
          attrs: { src: _vm.mediaBaseUrl + "quiz/tips/check.svg", alt: "" }
        }),
        _vm._v("\n      " + _vm._s(_vm.$t("quiz.list[19].tips[0]")) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tip" }, [
        _c("img", {
          attrs: { src: _vm.mediaBaseUrl + "quiz/tips/check.svg", alt: "" }
        }),
        _vm._v("\n      " + _vm._s(_vm.$t("quiz.list[19].tips[1]")) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tip" }, [
        _c("img", {
          attrs: { src: _vm.mediaBaseUrl + "quiz/tips/check.svg", alt: "" }
        }),
        _vm._v("\n      " + _vm._s(_vm.$t("quiz.list[19].tips[2]")) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tip" }, [
        _c("img", {
          attrs: { src: _vm.mediaBaseUrl + "quiz/tips/check.svg", alt: "" }
        }),
        _vm._v("\n      " + _vm._s(_vm.$t("quiz.list[19].tips[3]")) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tip" }, [
        _c("img", {
          attrs: { src: _vm.mediaBaseUrl + "quiz/tips/check.svg", alt: "" }
        }),
        _vm._v("\n      " + _vm._s(_vm.$t("quiz.list[19].tips[4]")) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("img", {
      staticClass: "bg",
      attrs: {
        src: _vm.mediaBaseUrl + "quiz/covers/" + _vm.gender + "/users-bg.png",
        alt: ""
      },
      on: {
        load: function($event) {
          return _vm.$emit("imageLoaded")
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }